"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _filtersLarge = _interopRequireDefault(require("./filters-large"));

var _filtersSmall = _interopRequireDefault(require("./filters-small"));

var formatCountDisplay = function formatCountDisplay(count) {
  return count === 1 ? "".concat(count, " item") : "".concat(count, " items");
};

var Wrapper = function Wrapper(_ref) {
  var childrenFunc = _ref.childrenFunc,
      count = _ref.count,
      idPrefix = _ref.idPrefix,
      heading = _ref.heading,
      onClick = _ref.onClick;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      expanded = _useState2[0],
      expand = _useState2[1];

  var formattedCountDisplay = typeof count === 'number' ? formatCountDisplay(count) : undefined;

  var clickHandle = function clickHandle() {
    expand(!expanded);
    onClick && onClick(expanded);
  };

  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_filtersLarge["default"], {
    countDisplay: formattedCountDisplay,
    idPrefix: idPrefix
  }, childrenFunc({
    id: 'large'
  })), _react["default"].createElement(_filtersSmall["default"], {
    countDisplay: formattedCountDisplay,
    onClick: clickHandle,
    idPrefix: idPrefix,
    heading: heading
  }, childrenFunc({
    id: 'small'
  })));
};

var _default = Wrapper;
exports["default"] = _default;